var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setBodyClass } from './body-class';
import { triggerPressOnDomLoaded } from './trigger-press';
import { reloadPageWhenTokenExpires } from './reload-page';
import { replaceStrings } from './replace-strings';
import { normalizeToken } from './normalizeToken';
const { getAccessToken } = window.gdiHost;
document.addEventListener('DOMContentLoaded', () => __awaiter(void 0, void 0, void 0, function* () {
    const { token, expires, decoded } = yield getAccessToken();
    const isAuthenticated = token.length > 0;
    if (isAuthenticated) {
        replaceStrings('.js-my-pages-template-string', normalizeToken(Object.assign({ name: '', firstName: '', lastName: '' }, decoded)));
        reloadPageWhenTokenExpires(expires);
    }
    if (!isAuthenticated) {
        triggerPressOnDomLoaded();
    }
    setBodyClass(isAuthenticated);
}));
